import VueCookie from 'vue-cookie'
import store from '@/store'
import {networkService as network} from '@/services'

export const adminService = {

  getStatus(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/entity-statuses/${id}?locale=en`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getStatuses() {
    return new Promise((resolve, reject) => {
      network
        .get(`/entity-statuses/all/en`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getStatusByName(name) {
    return new Promise((resolve, reject) => {
      network
        .get(`/entity-statuses/all/en`)
        .then((data) => {
          let res = {};
          data.data.forEach((item, index) => {
            if(item.name === name) {
              res = item
            }
          })
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getType(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/event-types/${id}?locale=en`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getTypes() {
    return new Promise((resolve, reject) => {
      network
        .get(`/event-types/all/en`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getExhibitors() {
    return new Promise((resolve, reject) => {
      network
        .get(`api/exhibitors.json`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  editRoles(userId, roles) {
    return new Promise((resolve, reject) => {
      network
        .post(`/admin/editRoles/${userId}`, {
          userRoles: roles,
        })
        .then((data) => resolve(data))
        .catch((err) => reject(err))
    })
  },
}
